import {combineReducers, Reducer} from 'redux'
import {HyperLinkMenusState} from '@models/hyperLinkMenu'
import {HyperLinkMenusActionTypes} from '@actions/hyperLinkMenu';


// Type-safe initialState!
export const initialState: HyperLinkMenusState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case HyperLinkMenusActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, hyperLinkMenu) => {
                    obj[hyperLinkMenu.id] = {
                        ...hyperLinkMenu,
                        is_fetched: false,
                        ...(state[hyperLinkMenu.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case HyperLinkMenusActionTypes.CREATE_SUCCESS: {
            const hyperLinkMenu = action.payload;
            return {
                ...state,
                [hyperLinkMenu.id]: hyperLinkMenu
            };
        }

        case HyperLinkMenusActionTypes.UPDATE_SUCCESS: {
            const hyperLinkMenu = action.payload;
            return {
                ...state,
                [hyperLinkMenu.id]: {
                    ...state[hyperLinkMenu.id],
                    ...hyperLinkMenu
                }
            };
        }

        case HyperLinkMenusActionTypes.FETCH_ITEM_SUCCESS: {
            const hyperLinkMenu = action.payload;
            return {
                ...state,
                [hyperLinkMenu.id]: {
                    ...state[hyperLinkMenu.id],
                    ...hyperLinkMenu,
                    is_fetched: true
                },
            };
        }

        case HyperLinkMenusActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case HyperLinkMenusActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case HyperLinkMenusActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case HyperLinkMenusActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case HyperLinkMenusActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case HyperLinkMenusActionTypes.DELETE_SUCCESS:
            return state - 1;

        case HyperLinkMenusActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case HyperLinkMenusActionTypes.FETCH_REQUEST: {
            return true;
        }

        case HyperLinkMenusActionTypes.FETCH_SUCCESS:
        case HyperLinkMenusActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<HyperLinkMenusState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as hyperLinkMenuReducer}


//Selectors
export const getHyperLinkMenusList = hyperLinkMenus => hyperLinkMenus.allIds.map(id => hyperLinkMenus.byId[id]);

export const getHyperLinkMenuById = (hyperLinkMenus, id) => hyperLinkMenus.byId[id];